import script from "./BusinessReviews.vue?vue&type=script&setup=true&lang=js"
export * from "./BusinessReviews.vue?vue&type=script&setup=true&lang=js"

import "./BusinessReviews.vue?vue&type=style&index=0&id=5404ade3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5404ade3"]])

export default __exports__